import i18n from '@/utils/i18n';
import React from 'react';
import { ChooseSubstitutionList } from '@/components/substitutions/choose-substitution-list';
import { PageContainer } from '@/components/page-container';
import { StackScreenProps } from '@react-navigation/stack';
import { SUBSTITUTION_ROUTES } from '@/navigators/routes';
import { SubstitutionStackParams } from '@/navigators/types';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export type Props = StackScreenProps<
  SubstitutionStackParams,
  SUBSTITUTION_ROUTES.ChooseSubstitution
>;

export const ChooseSubstitutionScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const {
    availabilityMap,
    fulfillmentDate,
    itemWithSubstitute,
    orderUUID,
    substitutionListOptions,
    variantPacksInOrder,
  } = route.params;
  const { bottom } = useSafeAreaInsets();
  return (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        showBackButton: true,
        showShadow: false,
        title: i18n.t('recommended_substitutions'),
      }}
    >
      <ChooseSubstitutionList
        availabilityMap={availabilityMap}
        extraBottomMargin={bottom}
        itemListOptions={substitutionListOptions}
        onSearchPress={() => {
          navigation.navigate(SUBSTITUTION_ROUTES.SearchCatalog, {
            fulfillmentDate,
            itemWithSubstitute,
            orderUUID,
            variantPacksInOrder,
          });
        }}
        onSelect={(substituteListOption, substitutionQuantity) => {
          navigation.navigate(SUBSTITUTION_ROUTES.SelectSubstitutionQuantity, {
            itemWithSubstitute,
            orderUUID,
            substituteListOption,
            substitutionQuantity,
          });
        }}
      />
    </PageContainer>
  );
};
